import React, { useRef, useState, useEffect } from 'react';
import './PriceSlider.css';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

const PriceSlider = ({ onPriceChange, minPrice = 0, maxPrice = 5000, initialMin = 0, initialMax = 5000 }) => {
  const trackRef = useRef(null);
  const [minVal, setMinVal] = useState(initialMin);
  const [maxVal, setMaxVal] = useState(initialMax);
  const [isOpen, setIsOpen] = useState(true);

  // Sync internal state if initialMin or initialMax props change
  useEffect(() => {
    if (initialMin !== minVal) {
      setMinVal(initialMin);
    }
    if (initialMax !== maxVal) {
      setMaxVal(initialMax);
    }
  }, [initialMin, initialMax]); // Only react to prop changes

  const getPercentage = (val) => {
    // Ensure division by zero is handled if minPrice can equal maxPrice
    const range = maxPrice - minPrice;
    if (range === 0) return 0; // Or 100 if val equals maxPrice, depends on desired behavior
    return ((val - minPrice) / range) * 100;
  };

  const handleMouseDown = (handle) => (e) => {
    e.preventDefault();
    const onMouseMove = (moveEvent) => {
      const track = trackRef.current;
      const rect = track.getBoundingClientRect();
      const x = moveEvent.clientX - rect.left;
      let percent = (x / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));
      const value = Math.round(minPrice + ((maxPrice - minPrice) * percent) / 100);

      if (handle === 'min') {
        setMinVal(Math.min(value, maxVal - 50));
      } else {
        setMaxVal(Math.max(value, minVal + 50));
      }
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  useEffect(() => {
    // Debounce the price change to avoid too many API calls
    const timeoutId = setTimeout(() => {
      onPriceChange(minVal, maxVal);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [minVal, maxVal, onPriceChange]);

  return (
    <div className="price-filter">
      <div
        className="price-filter-header"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="price-filter-title">Price</span>
        <div className="price-filter-arrow">
          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        </div>
      </div>

      {isOpen && (
        <>
          <div className="slider-track" ref={trackRef}>
            <div className="slider-bg"></div>

            <div
              className="slider-active"
              style={{
                left: `${getPercentage(minVal)}%`,
                width: `${getPercentage(maxVal) - getPercentage(minVal)}%`,
              }}
            ></div>

            <div
              className="slider-handle"
              style={{ left: `${getPercentage(minVal)}%` }}
              onMouseDown={handleMouseDown('min')}
            ></div>

            <div
              className="slider-handle"
              style={{ left: `${getPercentage(maxVal)}%` }}
              onMouseDown={handleMouseDown('max')}
            ></div>
          </div>

          <span className="price-range-label">
            Price: Ksh {minVal} — Ksh {maxVal}
          </span>
        </>
      )}
    </div>
  );
};

export default PriceSlider;
